import styled from 'styled-components';

export const StyledWrapper = styled.div`
  background: #e8ebed;
  padding: 20px;
  display: flex;
  align-items: center;
  border-radius: 4px;
`;
